import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { Check, Trophy } from '../../assets/images';
import { useTranslation } from 'react-i18next';

const ChallengeResult = ({
    type = 'fail', // 'complete' 또는 'fail'
    sx = {},
    width = '100%',
    height = '100%',
    message = null, // null이면 기본 메시지 사용
    fontSize = '32px',
    rotation = 350,
    opacity = 0.3,
}) => {
    const { t } = useTranslation();
    const theme = useTheme();

    // 완료 상태 확인 (complete)
    const isComplete = type === 'complete';
    const defaultMessage = isComplete ? t('completed_title') : t('failed_title');
    const displayMessage = message || defaultMessage;

    return (
        <Box
            sx={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                height,
                width,
                borderRadius: '20px',
                overflow: 'hidden',
                zIndex: 9999,
                ...sx
            }}
        >
            {/* 검은색 오버레이 */}
            <Box
                sx={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: theme.palette.figma.black,
                    opacity,
                    borderRadius: '20px',
                }}
            />

            {/* 결과 메시지 및 아이콘 */}
            <Box
                sx={{
                    position: 'absolute',
                    bottom: '78.77px',
                    right: '96.81px',
                    transform: `translate(50%, 100%) rotate(${rotation}deg)`,
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '5px',
                    zIndex: 10000,
                }}
            >
                {/* 메시지 */}
                <Typography
                    sx={{
                        fontSize,
                        fontWeight: 600,
                        color: theme.palette.figma.buttonText,
                        textAlign: 'center',
                        letterSpacing: '-0.96px',
                        lineHeight: 'normal',
                        whiteSpace: 'nowrap',
                    }}
                >
                    {displayMessage}
                </Typography>

                {/* 완료일 때 Check 아이콘 표시 */}
                {isComplete && (
                    <Box
                        sx={{
                            width: '40px',
                            height: '40px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            flexShrink: 0,
                        }}
                    >
                        <Check
                            size={40}
                            backgroundColor="#FFCC00"
                            checkColor="#FFFFFF"
                        />
                    </Box>
                )}
            </Box>
        </Box>
    );
};

export default ChallengeResult;

